import { PricePillProps } from "@/types/ui-kit/decorations";
import React from "react";

export const PricePill: React.FC<PricePillProps> = ({ title }) => {
  return (
    <>
      <span className="flex items-center justify-center rounded-full bg-orange px-[10px] py-[5px] text-center font-sans text-xs font-normal text-white">
        {title}
      </span>
    </>
  );
};
